module.exports = __webpack_public_path__ + "assets/img/bg2@2x.7191964a.png";